import React from 'react'
import styles from './BlogEditor.module.scss'

function ToolButton({ active, disabled, onClick, children, title }) {
  return (
    <button
      type="button"
      title={title}
      className={`${styles.toolBtn} ${active ? styles.toolBtnActive : ''}`.trim()}
      disabled={disabled}
      onMouseDown={(event) => {
        event.preventDefault()
        if (!disabled) onClick()
      }}
    >
      {children}
    </button>
  )
}

function BlogToolbar({ editor, lockBlockquote = false }) {
  const disabled = !editor

  const setLink = () => {
    if (!editor) return
    const previous = editor.getAttributes('link').href || ''
    // eslint-disable-next-line no-alert
    const url = window.prompt('Посилання (URL)', previous)
    if (url === null) return
    const trimmed = url.trim()
    if (!trimmed) {
      editor.chain().focus().extendMarkRange('link').unsetLink().run()
      return
    }
    editor.chain().focus().extendMarkRange('link').setLink({ href: trimmed }).run()
  }

  const can = (check) => {
    if (!editor) return false
    try {
      return Boolean(check())
    } catch (_err) {
      return false
    }
  }

  const quoteActive = !disabled && (lockBlockquote || editor.isActive('blockquote'))
  const quoteDisabled = disabled || lockBlockquote

  return (
    <div className={disabled ? styles.toolbarDisabled : styles.toolbar}>
      <ToolButton
        title="Скасувати"
        disabled={!can(() => editor.can().undo())}
        onClick={() => editor.chain().focus().undo().run()}
      >
        ↶
      </ToolButton>
      <ToolButton
        title="Повторити"
        disabled={!can(() => editor.can().redo())}
        onClick={() => editor.chain().focus().redo().run()}
      >
        ↷
      </ToolButton>
      <span className={styles.toolSep} />
      <ToolButton
        title="Заголовок H2"
        disabled={disabled || lockBlockquote}
        active={!disabled && editor.isActive('heading', { level: 2 })}
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
      >
        H2
      </ToolButton>
      <ToolButton
        title="Заголовок H3"
        disabled={disabled || lockBlockquote}
        active={!disabled && editor.isActive('heading', { level: 3 })}
        onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
      >
        H3
      </ToolButton>
      <ToolButton
        title="Заголовок H4"
        disabled={disabled || lockBlockquote}
        active={!disabled && editor.isActive('heading', { level: 4 })}
        onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()}
      >
        H4
      </ToolButton>
      <ToolButton
        title="Звичайний текст"
        disabled={disabled || lockBlockquote}
        active={!disabled && !lockBlockquote && editor.isActive('paragraph')}
        onClick={() => editor.chain().focus().setParagraph().run()}
      >
        P
      </ToolButton>
      <span className={styles.toolSep} />
      <ToolButton
        title="Жирний"
        disabled={disabled}
        active={!disabled && editor.isActive('bold')}
        onClick={() => editor.chain().focus().toggleBold().run()}
      >
        <strong>B</strong>
      </ToolButton>
      <ToolButton
        title="Курсив"
        disabled={disabled}
        active={!disabled && editor.isActive('italic')}
        onClick={() => editor.chain().focus().toggleItalic().run()}
      >
        <em>I</em>
      </ToolButton>
      <ToolButton
        title="Підкреслення"
        disabled={disabled}
        active={!disabled && editor.isActive('underline')}
        onClick={() => editor.chain().focus().toggleUnderline().run()}
      >
        <span className={styles.underlineMark}>U</span>
      </ToolButton>
      <ToolButton title="Посилання" disabled={disabled} active={!disabled && editor.isActive('link')} onClick={setLink}>
        Link
      </ToolButton>
      <span className={styles.toolSep} />
      <ToolButton
        title="Маркований список"
        disabled={disabled || lockBlockquote}
        active={!disabled && editor.isActive('bulletList')}
        onClick={() => editor.chain().focus().toggleBulletList().run()}
      >
        • Список
      </ToolButton>
      <ToolButton
        title="Нумерований список"
        disabled={disabled || lockBlockquote}
        active={!disabled && editor.isActive('orderedList')}
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
      >
        1. Список
      </ToolButton>
      <ToolButton
        title="Цитата"
        disabled={quoteDisabled}
        active={quoteActive}
        onClick={() => editor.chain().focus().toggleBlockquote().run()}
      >
        « »
      </ToolButton>
    </div>
  )
}

export default BlogToolbar
